import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import RowNoData from '@/components/elements/RowNoData';
import { Comentario, } from '@/objects/Articles';
import Subtitulo from '@/components/elements/Subtitulo';
import RowPuntuarLibro from '@/components/elements/listas/lista_puntuar/RowPuntuarLibro';

function PuntuacionesLibros() {

    const { articulosQueries } = useServices();

    const [comentarios, setComentarios] = React.useState<Comentario[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        cargarPuntuaciones();
    }, []);

    function cargarPuntuaciones() {
        const datosUsuario = cargarDatosUsuario();
        articulosQueries?.obtenerTodosLosComentariosByIdUser(Number(datosUsuario?.id_user)).then((response: AxiosResponse<Comentario[]>) => {
            if (response.status == 200) {
                setComentarios(response.data);
            }
        }
        ).catch((error: any) => {

        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%', alignContent: "center", alignItems: "center" }}>
            <TituloPrincipalH1 texto={t("menu:secciones.puntuaciones.titulo")} />
            <Subtitulo texto={t("menu:secciones.puntuaciones.compras_sin_puntuar")} />
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                {comentarios.length > 0 ? comentarios.map((comentario: Comentario, index: number) => {
                    return (
                        <section style={{ display: 'flex', flexDirection: 'column', width: "100%", margin: "10px", alignItems: "center" }} key={index}>
                            <RowPuntuarLibro t={t} comentario={comentario} onCargar={cargarPuntuaciones} />
                        </section>
                    );
                }) : <RowNoData texto={t("menu:secciones.puntuaciones.no_hay_libros_para_puntuar_compra_uno")} />}
            </section>
        </section>
    );
}

export default PuntuacionesLibros;